import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, Button, Input, Space } from 'antd';

const SqlNodeConfigModal = ({ open, onCancel, onSave, initialConfig = {}, availableTables = {} }) => {
    const [form] = Form.useForm();
    const [tableFields, setTableFields] = useState([]);
    useEffect(() => {
        if (initialConfig && typeof initialConfig === 'object' && !Array.isArray(initialConfig)) {
            form.setFieldsValue(initialConfig);
            if ('sourceTable' in initialConfig && typeof initialConfig.sourceTable === 'string') {
                setTableFields(availableTables[initialConfig.sourceTable] || []);
            }
        }
    }, [initialConfig]);
    const handleTableChange = (tableName) => {
        setTableFields(availableTables?.[tableName] || []);
        form.setFieldsValue({ sqlQuery: ''});
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            onOk={() => form.validateFields().then(onSave)}
            title="Cấu hình SQL Node"
            okText="Lưu"
        >
            <Form form={form} layout="vertical">
                    <>
                        {/* BẢNG NGUỒN */}
                        <Form.Item name="sourceTable" label="Bảng nguồn (Partner)">
                            <Input
                                placeholder="Nhập bảng nguồn, ví dụ: partner_orders"
                                onChange={(e) => handleTableChange(e.target.value)}
                            />
                        </Form.Item>

                        {/* FIELD SOURCE */}
                        <Form.Item
                            name="sqlQuery"
                            label="Câu lệnh truy vấn"
                            rules={[{ required: true, message: 'Vui lòng nhập câu truy vấn' }]}
                        >
                            <Input.TextArea
                                placeholder="Ví dụ: select * from partner"
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={(e) => {
                                    const raw = e.target.value || '';
                                    const fields = raw
                                        .split(',')
                                        .map((f) => f.trim())
                                        .filter(Boolean);
                                    form.setFieldsValue({ fields }); // Trường dùng trong BE
                                }}
                            />
                        </Form.Item>

                    </>


                {/* BẢNG ĐÍCH */}
                {initialConfig?.flowType !== 'internal_push' && (
                    <Form.Item name="targetTable" label="Bảng đích (VDG)">
                        <Input placeholder="Nhập bảng đích (vdg_users)" />
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default SqlNodeConfigModal;
